import { render, staticRenderFns } from "./TranslationsTabs.vue?vue&type=template&id=389413ec&"
import script from "./TranslationsTabs.vue?vue&type=script&lang=js&"
export * from "./TranslationsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports